import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext.jsx';
import styles from './NotFoundPage.module.css';

export default function NotFoundPage() {
  const { t } = useLanguage();
  return (
    <div className={styles.wrapper}>
      <h1>{t('notFound.title')}</h1>
      <p>{t('notFound.body')}</p>
      <Link to="/">{t('notFound.backLink')}</Link>
    </div>
  );
}
